<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('CreateVisitPoint')"
			:subTitle="$t('general.SubTitleZonification')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<visit-point-create-tab-account
			v-if="
				visitpointCreatePermission &&
				objectRPermission &&
				typeConfigRPermission &&
				statusRPermission &&
				roleRPermission
			"
			:visit_point="visitPoint"
			:manual_data_id="manualDataId"
			:upload_file_id="uploadFileId"
		/>
		<not-permission v-else :message="message"></not-permission>
	</div>
</template>

<script>
// Componentes
import VisitPointCreateTabAccount from "./VisitPointCreateTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
// Models
import VisitPoint from "@/models/VisitPoint.js";
// Store
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	components: {
		VisitPointCreateTabAccount,
		NotPermission,
	},
	data() {
		return {
			activeTab: 0,
			visitPoint: new VisitPoint({}),
			manualDataId: 0,
			uploadFileId: 0,
		};
	},
	computed: {
		visitpointCreatePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_C");
		},
		objectRPermission() {
			return this.$store.getters.checkPermission("OBJECTS_R");
		},
		typeConfigRPermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_R");
		},
		roleRPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
		statusRPermission() {
			return this.$store.getters.checkPermission("STATUS_R");
		},
		message() {
			return `${this.$t(
				"Permissions.RequiredPermissions"
			)} "VISIT_POINT_C" , "ROLE_R", "STATUS_R", "OBJECTS_R", "TYPE_CONFIG_R"`;
		},
	},
	mounted() {
		const visit_point = this.$route.params.visit_point;
		const manual_data_id = this.$route.params.manual_data_id;
		const upload_file_id = this.$route.params.upload_file_id;
		if (visit_point) {
			this.visitPoint = new VisitPoint(visit_point);
			this.manualDataId = manual_data_id;
			this.uploadFileId = upload_file_id;
		}
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
};
</script>
